import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const IncidentHeader = ({ incident, onStatusChange, onEscalate, onAssign, currentUser }) => {
  const getSeverityColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case 'critical': return 'bg-error text-error-foreground';
      case 'high': return 'bg-warning text-warning-foreground';
      case 'medium': return 'bg-accent text-accent-foreground';
      case 'low': return 'bg-success text-success-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'open': return 'bg-error text-error-foreground';
      case 'in progress': return 'bg-warning text-warning-foreground';
      case 'resolved': return 'bg-success text-success-foreground';
      case 'closed': return 'bg-muted text-muted-foreground';
      default: return 'bg-secondary text-secondary-foreground';
    }
  };

  const getSLAStatus = (slaHours) => {
    if (slaHours <= 2) return { color: 'text-error', icon: 'AlertTriangle' };
    if (slaHours <= 8) return { color: 'text-warning', icon: 'Clock' };
    return { color: 'text-success', icon: 'CheckCircle' };
  };

  const slaStatus = getSLAStatus(incident?.slaHoursRemaining);

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
        {/* Left Section - Incident Info */}
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-3">
            <h1 className="text-2xl font-semibold text-foreground">{incident?.title}</h1>
            <span className={`px-2 py-1 text-xs font-medium rounded-full ${getSeverityColor(incident?.severity)}`}>
              {incident?.severity}
            </span>
            <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(incident?.status)}`}>
              {incident?.status}
            </span>
          </div>
          
          <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mb-4">
            <div className="flex items-center gap-1">
              <Icon name="Hash" size={16} />
              <span>ID: {incident?.id}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Calendar" size={16} />
              <span>Created: {new Date(incident.createdAt)?.toLocaleDateString()}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Clock" size={16} />
              <span>Updated: {new Date(incident.updatedAt)?.toLocaleString()}</span>
            </div>
            <div className={`flex items-center gap-1 ${slaStatus?.color}`}>
              <Icon name={slaStatus?.icon} size={16} />
              <span>SLA: {incident?.slaHoursRemaining}h remaining</span>
            </div>
          </div>

          <div className="flex items-center gap-2 text-sm">
            <Icon name="User" size={16} className="text-muted-foreground" />
            <span className="text-muted-foreground">Assigned to:</span>
            <span className="font-medium text-foreground">{incident?.assignedTo || 'Unassigned'}</span>
          </div>
        </div>

        {/* Right Section - Actions */}
        <div className="flex flex-col sm:flex-row lg:flex-col gap-2 min-w-0 lg:min-w-[200px]">
          <Button
            variant="outline"
            size="sm"
            iconName="Edit"
            iconPosition="left"
            onClick={() => onStatusChange(incident?.id)}
            className="w-full sm:w-auto lg:w-full"
          >
            Update Status
          </Button>
          
          <Button
            variant="secondary"
            size="sm"
            iconName="UserPlus"
            iconPosition="left"
            onClick={() => onAssign(incident?.id)}
            className="w-full sm:w-auto lg:w-full"
          >
            Reassign
          </Button>
          
          <Button
            variant="warning"
            size="sm"
            iconName="AlertTriangle"
            iconPosition="left"
            onClick={() => onEscalate(incident?.id)}
            className="w-full sm:w-auto lg:w-full"
          >
            Escalate
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IncidentHeader;